/*
Utils functions to be used across the code
*/
export const formatString = (template, ...args) => {
  return template.replace(/{([0-9]+)}/g, (match, index) => {
    return typeof args[index] === 'undefined' ? match : args[index];
  });
};

export const decodeHtml = (str) => {
  if (typeof str !== 'string') return str;
  
  const htmlEntities = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#34;': '"',
    '&#x22;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&apos;': "'",
    '&amp;': '&',
    '&#38;': '&',
    '&#x26;': '&',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&cent;': '¢',
    '&pound;': '£',
    '&yen;': '¥',
    '&euro;': '€',
    '&copy;': '©',
    '&reg;': '®',
    '&deg;': '°'
  };
  
  let result = str.replace(/&[a-z0-9#]+;/gi, (match) => {
    return htmlEntities[match.toLowerCase()] || match;
  });
  return result.replace(/\n/g, '<br>');
};

export const isValueEmpty = (value) => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  
  if (typeof value === 'string' && (value === 'undefined' || value === 'null')) {
    return true;
  }
  
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0;
  }
  
  return false;
};

export const isSignatureRequired = (value) => {
  if (value === true || value === 1) {
    return true;
  }

  if (typeof value === 'string') {
    const normalizedValue = value.trim().toLowerCase();
    return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'yes';
  }

  return false;
};

export const testUpdate = (val) => {
  console.log(val);
};

// IANA zone id (e.g. "America/Toronto") for the device recording the task times,
// so Flow can render the technician's timestamps in their own local time instead
// of the raw UTC instant.
export const getDeviceTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (error) {
    return null;
  }
};

// A task's total time is usable only when it is a positive number of seconds.
export const hasTotalTime = (task) => Number(task?.timeSpent) > 0;

export const MS_PER_MINUTE = 60 * 1000;

// The backend rejects intervals shorter than a full minute, so compare elapsed time, not minute buckets.
export const isEndAfterStartByMinute = (startMs, endMs) => endMs - startMs >= MS_PER_MINUTE;

// Earliest instant a picker (minute precision) can show that is still a full minute after startMs.
export const getMinEndTimeMs = (startMs) => Math.ceil((startMs + MS_PER_MINUTE) / MS_PER_MINUTE) * MS_PER_MINUTE;

// ISO instant -> value for <input type="datetime-local"> (device-local wall time, minute precision).
export const toDateTimeLocalValue = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// <input type="datetime-local"> value (device-local wall time) -> ISO instant, or null if invalid.
export const fromDateTimeLocalValue = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date.toISOString();
};
